<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Aprobar Pallets sif ({{num_sif}})</h1>
      <!--   <div>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione...">
                </b-form-select>
              </b-col>
              <b-col>
                <label for="productSelect">Seleccione Producto</label>
                <b-form-select
                  id="productSelect"
                  v-model="selected.product"
                  :plain="true"
                  :options="selectOptions.products"
                  value="Seleccione...">
                </b-form-select>
              </b-col>
              <b-col>
                <label for="conditionSelect">Condición</label>
                <b-form-select
                  id="conditionSelect"
                  v-model="selected.condition"
                  :plain="true"
                  :options="selectOptions.conditions"
                  value="Seleccione...">
                </b-form-select>
              </b-col>
              <b-col>
                <label for="productTypeSelect">Tipo de Producto</label>
                <b-form-select
                  @change="getProductSet"
                  id="productTypeSelect"
                  v-model="selected.product_type"
                  :plain="true"
                  :options="selectOptions.product_types"
                  value="Seleccione...">
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </div> -->
         <br>
          <b-button @click="approvePallet"  variant="primary" class="btn  float-right" >APROBAR</b-button>
          <br>
           <br>
        <hr>

        <v-client-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable">

           <template slot="id" scope="props">
      <input type="checkbox" :ref="'check'+props.index"
      @click="unmarkAll($event,props.row.total_net_kilograms,props.index,'check'+props.index)"
      class="form-check"
      :value="props.row"
      v-model="markedRows">
    </template>
        <!--   <template slot="condition" slot-scope="props">
            <b-badge pill :variant="getBadge(props.row.condition)">{{props.row.condition}}</b-badge>
          </template>
          <template slot="daystay" slot-scope="props">
            <div style="text-align: right">
              <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
                {{props.row.daystay}}
              </b-badge>
            </div>
          </template> -->
          <div slot="afterFilter">
            <!-- <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
              <download-excel
                  :data = "data"
                  :fields = "json_fields"
                  worksheet = "Data"
                  name = "stock.xls">
                  <b-button size="sm" variant="xing" class="mr-1 btn-brand" @click=""><i class="fa fa-file-excel-o"></i><span>.xls</span></b-button>
              </download-excel>
            </b-col> -->

          </div>

       <!--    <div slot="net_kilograms" slot-scope="props">
            <div style="text-align: right">{{props.row.net_kilograms}}</div>
          </div>
          <div slot="quantity" slot-scope="props">
            <div style="text-align: right">{{props.row.quantity}}</div>
          </div>
          <div slot="dispatch_waybill_number" slot-scope="props">
            <div style="text-align: right">{{props.row.dispatch_waybill_number}}</div>
          </div>
          <div slot="dispatch_waybill_date" slot-scope="props">
            <div style="text-align: right">{{props.row.dispatch_waybill_date}}</div>
          </div>

          <div slot="child_row" slot-scope="props">
            Contenido originado de la Guia de Recepción <b># {{props.row.waybill_number}}</b>, con fecha de arribo <b>{{props.row.waybill_date}}</b>
          </div> -->

        </v-client-table>

      </b-card-body>
    </b-card>

  </div>

</template>



<script>
  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'
  import JsonExcel from 'vue-json-excel'
  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'

  numeral.locale('es');




  var d = new Date();

  Vue.use(ClientTable);
  Vue.component('downloadExcel', JsonExcel);

  export default {
    name: 'formAprobarPallet',
    components: {
      ClientTable,
    },
     props: ['idInspection'],
    mounted(){
      this.getPallet();
    },
    created () {

    },
    data () {
      return {
        num_sif:"",
			  markedRows:[],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        json_fields: {
          'Pallet': 'number',
          'Huerto': 'origins',
          'Formato': 'container',
          'Variedad': 'varieties',
          'Cajas': 'total_quantity',
          'kilogramos_netos': 'total_net_kilograms',
          'kilogramos_brutos': 'total_gross_kilograms',


        },
        columns: [
           'id',
          'number',
          'origins',
          'container',
          'varieties',
          'total_quantity',
          'total_net_kilograms',
          'total_gross_kilograms',

        ],
        selected: {
          product: "",
          product_type: "",
          condition: "",
          month: d.getMonth()+1,
        },
        selectOptions:{
          products: [],
          product_types: [],
          conditions:[
            {value: "", text: "-------"},
            {value: "Orgánico", text: "Orgánico"},
            {value: "Convencional", text: "Convencional"},
            {value: "Org. System Approach", text: "Org. System Approach"},
          ],
          months:[
            {value: 1, text: "Enero"},
            {value: 2, text: "Febrero"},
            {value: 3, text: "Marzo"},
            {value: 4, text: "Abril"},
            {value: 5, text: "Mayo"},
            {value: 6, text: "Junio"},
            {value: 7, text: "Julio"},
            {value: 8, text: "Agosto"},
            {value: 9, text: "Septiembre"},
            {value: 10, text: "Octubre"},
            {value: 11, text: "Noviembre"},
            {value: 12, text: "Diciembre"},

          ]
        },
        productSet: [],
        data: [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        options: {

          texts: {
                filter: "Filtrar:",
                filterBy: 'Filtrar por {column}',
                count:' ',
                filterPlaceholder:"Buscar...",
                columns:'Columnas',
                limit:"Registros:",
            },
          listColumns: {
            waybill_date: [{
                        id: 1,
                        text: 'Enero'
                    },
                    {
                        id: 2,
                        text: 'Febrero',
                    },
                    {
                        id: 3,
                        text: 'Marzo'
                    },
                    {
                        id: 4,
                        text: 'Abril'
                    }
                ]
          },
          perPage: 10,
          dateFormat: 'DD/MM/YYYY',
          // columnsDropdown: true,

          filterByColumn: false,
           headings: {
			      id:'',
            number: 'Pallet',
            origins: 'Origen',
            container: 'Contenedor',
            varieties: 'Variedad',
            total_quantity: 'Cajas',
            total_net_kilograms: 'kilogramos netos',
            total_gross_kilograms: 'kilogramos brutos',
          },
          sortable: ['number' ,'company_name'],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },

      }
    },
    watch:{
      selected: {
         handler(val){
           this.getPallet(this.selected.month, this.selected.condition, this.selected.product, this.selected.product_type)
           this.getProductSet(this.selected.product)
         },
         deep: true
      }
    },
    methods: {
     getpalletscheck() {
         return this.markedRows;
      },
       approvePallet(){

         this.$swal
         .fire({
           title: "Seguro que quieres terminar?",
           text: "",
           type: "warning",
           showCancelButton: true,
           confirmButtonColor: "#3085d6",
           cancelButtonColor: "#d33",
           cancelButtonText: "No",
           confirmButtonText: "SI"
         })
         .then(result => {

           if (result.value)
           {

              var padre=this;
              var arrayPallets=this.markedRows;

              if(Object.keys(arrayPallets).length > 0)
              {

              const formData = {
                id_inspecion:this.idInspection,
                pallets:arrayPallets
              };

                padre.$axios.put('/api/comex/inspection/approve_pallet/', formData)
               .then(res => {

                  padre.$swal.fire(
                  "Operación realizada con éxito",
                  "",
                  "success"
                    );

                padre.$router.push("/exportacion/lista-inspeccion/");

                  })
                .catch(error => {

                      padre.$swal.fire(
                      "Problemas al terminar proceso",
                      "",
                      "error"
                      );


                      });


            }else{

                 padre.$swal.fire(
           "Por favor seleccione por lo menos un pallet",
           "",
           "info"
           );

            }


           }else{



           }


         });


     },
       unmarkAll($event,kilosNetos,index,obj) {

     //console.log($event.target.checked);

        if($event.target.checked == false)
        {

           console.log("No chekiando");


        }else{

         console.log("chekiando");


        }

        this.allMarked = false;
      },
      getPallet()
      {

     this.$axios.get('/api/comex/inspection/specific_detailed/', {
          params: {
          id: this.idInspection,
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {
           this.data = res.data.data[0].inspection_list;
            this.num_sif=res.data.data[0].sif_number;
           console.log(res.data.data[0].inspection_list);


        })
       .catch(error => {
          console.log(error.response)
        });

      },

      getProductSet(a){
        this.$axios.get ('/production/get_product_set/'+ a )
        .then(res => {
          this.selectOptions.product_types = res.data.product_types
        })
        .catch(error => console.log('Product not selected.'))
      },
    },
  };
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }
    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__number-field {
      border: 4px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }
    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
